var replaceDescription = function replaceDescription(offerDescription, tacDescription) {
  if (offerDescription && tacDescription) {
    var mes = offerDescription.match(/\d+\smeses/)[0];
    return "".concat(tacDescription, " ").concat(mes);
  }
  return offerDescription || '';
};
export default replaceDescription;